import React from 'react';
import { useRouter } from 'next/navigation';
import { Card } from 'src/components';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { useProfile } from 'src/context/providers/ProfileProvider';
import { getProfileUrl } from 'src/utils/profileUrl';
import { useDrawer } from 'src/hooks/drawers/useDrawer';

const OverviewButton = () => {
  const router = useRouter();
  const { entityDetails } = useProfile();
  const { closeDrawer } = useDrawer();
  const providerId = entityDetails?.id;

  const handleClick = () => {
    router.push(getProfileUrl(entityDetails?.type, providerId));
    closeDrawer('profile');
  };

  if (!providerId) return null;

  return (
    <Card
      className="p-4 flex flex-col gap-2 bg-white hover:bg-gray-50 cursor-pointer"
      data-testid={`overview-button-${providerId}`}
      onClick={handleClick}
    >
      <div className="flex items-center gap-3">
        <div className="w-8 h-8  rounded-full flex items-center justify-center text-neutral-600">
          <Icon icon={faInfoCircle} size="xl" />
        </div>
        <div className="flex-1">
          <span className="font-bold text-primary">More Details</span>
          <p className="text-sm font-medium text-tertiary">
            Overall mix, top locations, & more
          </p>
        </div>
        <Icon
          icon={faChevronRight}
          className="text-xs text-secondary"
          aria-hidden="true"
        />
      </div>
    </Card>
  );
};

export default OverviewButton;
